import Vue from 'vue';
import Loading from '@/components/loading';
import InputSwitch from '@/components/input-switch';
import ImageInput from '@/components/image-input';
import InputSelect from '@/components/input-select';
import InputWysiwyg from '@/components/input-wysiwyg';
import InputColor from '@/components/input-color';
import NoContent from '@/components/no-content';

Vue.component('loading', Loading);
Vue.component('input-switch', InputSwitch);
Vue.component('image-input', ImageInput);
Vue.component('input-select', InputSelect);
Vue.component('input-wysiwyg', InputWysiwyg);
Vue.component('input-color', InputColor);
Vue.component('no-content', NoContent);
